<template>
  <div>
    <div
      v-loading.lock="loading"
      :element-loading-text="$t('connecting')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="p-5 overflow-hidden rounded-2xl bg-slate-100 mt-5 flex flex-col items-center"
    >
      <apexchart
        type="donut"
        ref="chartDonut"
        :width="400"
        :options="chartOptionsDonut"
        :series="seriesDonut"
      >
      </apexchart>
      <div
        class="flex flex-wrap gap-x-2 sm:gap-x-3 md:gap-x-5 lg:gap-x-14 justify-center items-center"
      >
        <div class="flex-1"></div>
        <div>
          <IconNumber
            class="text-indigo-800 mb-2 ml-auto"
            style="width: 24px; height: 24px"
          />
        </div>
        <div class="w-10 sm:w-16 text-cyan-600">
          <IconPercent class="text-cyan-800 mb-2 ml-auto" />
        </div>
        <div class="w-full"></div>
        <div class="flex-1">
          <div
            class="text-sm sm:text-lg leading-snug font-bold text-slate-500 flex items-center"
          >
            <div class="flex">
              <span
                class="rounded inline-block mr-2.5"
                style="width: 30px; height: 15px; background: #2dd4bf"
              ></span>
            </div>
            <p>
              {{ $t("sustainable_transport_structures") }}
            </p>
          </div>
        </div>
        <div>
          <p
            class="text-base sm:text-2xl leading-snug font-bold text-emerald-600"
          >
            {{ seismicData.first_seismic || 0 }}
          </p>
        </div>
        <div class="w-10 sm:w-16 text-right">
          <p class="text-base sm:text-2xl leading-snug font-bold text-cyan-600">
            {{
              Math.round(
                (seismicData.first_seismic /
                  seismicData.all_transport_infrastructure) *
                  100
              ) || 0
            }}
            %
          </p>
        </div>
        <div class="w-full"></div>
        <div class="flex-1">
          <div
            class="text-sm sm:text-lg leading-snug font-bold text-slate-500 flex items-center"
          >
            <div class="flex">
              <span
                class="rounded inline-block mr-2.5"
                style="width: 30px; height: 15px; background: #fed7aa"
              ></span>
            </div>
            <p>
              {{ $t("not_sustainable_transport") }}
            </p>
          </div>
        </div>
        <div>
          <p
            class="text-base sm:text-2xl leading-snug font-bold text-amber-600"
          >
            {{ seismicData.second_seismic || 0 }}
          </p>
        </div>
        <div class="w-10 sm:w-16 text-right">
          <p class="text-base sm:text-2xl leading-snug font-bold text-cyan-600">
            {{
              Math.round(
                (seismicData.second_seismic /
                  seismicData.all_transport_infrastructure) *
                  100
              ) || 0
            }}
            %
          </p>
        </div>
        <div class="w-full"></div>
        <div class="flex-1">
          <div
            class="text-sm sm:text-lg leading-snug font-bold text-slate-500 flex items-center"
          >
            <div class="flex">
              <span
                class="rounded inline-block mr-2.5"
                style="width: 30px; height: 15px; background: #fb7185"
              ></span>
            </div>
            <p>
              {{ $t("not_sustainable_transport4_structures") }}
            </p>
          </div>
        </div>
        <div>
          <p class="text-base sm:text-2xl leading-snug font-bold text-rose-600">
            {{ seismicData.third_seismic || 0 }}
          </p>
        </div>
        <div class="w-10 sm:w-16 text-right">
          <p class="text-base sm:text-2xl leading-snug font-bold text-cyan-600">
            {{
              Math.round(
                (seismicData.third_seismic /
                  seismicData.all_transport_infrastructure) *
                  100
              ) || 0
            }}
            %
          </p>
        </div>
      </div>
    </div>
    <div
      v-loading.lock="loading"
      :element-loading-text="$t('connecting')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="p-5 overflow-hidden rounded-2xl bg-slate-100 mt-5"
    >
      <div class="bar-chart">
        <apexchart
          type="bar"
          ref="chartBar"
          height="300"
          style="min-width: 1200px"
          :options="chartOptionsBar"
          :series="seriesBar"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
import IconNumber from "./Icons/iconNumber.vue";
import IconPercent from "./Icons/iconPercent.vue";
import LogoIcon from "@/assets/img/icons/logo.svg";

export default {
  name: "TransportChart",
  components: {
    IconNumber,
    IconPercent,
    LogoIcon,
  },
  data() {
    return {
      loading: false,
      seismicData: {},
      seriesDonut: [],
      seriesBar: [],
      categories_cyr: [
        "Андижон",
        "Бухоро",
        "Жиззах",
        "Қашқадарё",
        "Навоий",
        "Наманган",
        "Самарқанд",
        "Сурхондарё",
        "Сирдарё",
        "Тошкент ш.",
        "Тошкент",
        "Фарғона",
        "Хоразм",
        "Қ.Р.",
      ],
      categories_ru: [
        "Андижан",
        "Бухара",
        "Джиззах",
        "Кашкадарья",
        "Навои",
        "Наманган",
        "Самарканд",
        "Сурхандарья",
        "Сырдарья",
        "г. Ташкент",
        "Ташкент",
        "Фергана",
        "Хорезм",
        "К.Р.",
      ],
    };
  },
  computed: {
    chartOptionsDonut() {
      return {
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 90,
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: -30,
                },
                value: {
                  show: true,
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#3730A3",
                  offsetY: -10,
                  formatter: function (val) {
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                  },
                },
                total: {
                  showAlways: true,
                  show: true,
                  label: this.$t("total"), // 🌐 bu endi computed ichida
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#615E83",
                  formatter: function (w) {
                    return w.globals.seriesTotals
                      .reduce((a, b) => a + b, 0)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                  },
                },
              },
            },
          },
        },
        grid: {
          padding: {
            bottom: -120,
          },
        },
        states: {
          hover: {
            filter: { type: "none" },
          },
          active: {
            filter: { type: "none" },
          },
        },
        labels: [
          this.$t("sustainable_transport_structures"),
          this.$t("not_sustainable_transport"),
          this.$t("not_sustainable_transport4_structures"),
        ],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#2DD4BF", "#FED7AA", "#FB7185"],
        chart: {
          fontFamily: '"Nunito", sans-serif',
        },
        stroke: {
          colors: "#f1f5f9",
          width: 3,
        },
      };
    },
    chartOptionsBar() {
      return {
        chart: {
          fontFamily: '"Nunito", sans-serif',
        },
        colors: ["#2DD4BF", "#FED7AA", "#FB7185"],
        plotOptions: {
          bar: {
            columnWidth: "55%",
            borderRadius: 6,
            borderRadiusApplication: "end",
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 3,
          colors: ["transparent"],
        },
        xaxis: {
          categories:
            this.$i18n.locale === "ru"
              ? this.categories_ru
              : this.categories_cyr,
          labels: {
            rotate: 0,
            hideOverlappingLabels: false,
            trim: true,
            style: {
              colors: "#020617",
              fontSize: "14px",
              fontWeight: 500,
              cssClass: "apexcharts-xaxis-label",
            },
          },
        },
        fill: {
          opacity: 1,
        },
      };
    },
  },
  watch: {
    "$i18n.locale"() {
      // 🌐 til o‘zgarganda chart matnlarini yangilash
      this.$nextTick(() => {
        this.$refs.chartDonut?.updateOptions(this.chartOptionsDonut);
        this.$refs.chartBar?.updateOptions(this.chartOptionsBar);
        this.$refs.chartBar?.updateSeries([
          {
            name: this.$t("sustainable_transport_structures"),
            data: this.seriesBar[0].data,
          },
          {
            name: this.$t("not_sustainable_transport"),
            data: this.seriesBar[1].data,
          },
          {
            name: this.$t("not_sustainable_transport4_structures"),
            data: this.seriesBar[2].data,
          },
        ]);
      });
    },
  },
  mounted() {
    this.getTransportStatistics();
  },
  methods: {
    getTransportStatistics() {
      this.loading = true;
      axios
        .get(`/transport_facility_statistic/`)
        .then((result) => {
          this.seismicData = result.data?.seismic || {};
          this.seriesDonut = [
            this.seismicData.first_seismic || 0,
            this.seismicData.second_seismic || 0,
            this.seismicData.third_seismic || 0,
          ];
          this.seriesBar = [
            {
              name: this.$t("sustainable_transport_structures"),
              data: [],
            },
            {
              name: this.$t("not_sustainable_transport"),
              data: [],
            },
            {
              name: this.$t("not_sustainable_transport4_structures"),
              data: [],
            },
          ];
          this.categories_cyr = [];
          this.categories_ru = [];
          result.data?.chart.forEach((elem) => {
            this.seriesBar[0].data.push(elem.first_seismic || 0);
            this.seriesBar[1].data.push(elem.second_seismic || 0);
            this.seriesBar[2].data.push(elem.third_seismic || 0);
            this.categories_cyr.push(elem.region.name_cyr?.split(" "));
            this.categories_ru.push(elem.region.name_ru?.split(" "));
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.apexcharts-xaxis-label {
  white-space: pre-line !important;
}
.bar-chart {
  overflow-x: auto;
}
</style>
